import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { bandApi, playApi } from "../Api/api";

const UpdateTrupa = () => {

    let { id } = useParams();

    const navigate = useNavigate();

    const [band, setBand] = useState({});
    const [play, setPlay] = useState({});

    useEffect(() => {
        bandApi.getBandById(id)
            .then((res) => {
                setBand(res.data);
                setPlay(res.data.play);
            })
            .catch(() => {
                setBand(null);
                setPlay(null);
            })
    }, []);

    const handleChange = (e, setField) => {
        const { name, value } = e.target;
        setField((prev) => ({ ...prev, [name]: value }));
    }

    const updateButton = async () => {
        bandApi.updateBand(band, id)
            .then(() => {
                playApi.updatePlay(play, play.id)
                    .then(() => {
                        toast.success('🦄 Trupa actualizata cu succes! 🐊', {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        setTimeout(() => {
                            navigate("/trupe")
                        }, 2000);
                    })
                    .catch((err) => {
                        console.error(err);
                        toast.error('🦄Eroare la datele introduse!!!🐊', {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    })
            })
            .catch((err) => {
                console.error(err);
                toast.error('🦄Eroare la datele introduse!!!🐊', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            })
    }


    return (
        <div className="update-trupa page-trupe">
            <label htmlFor="bandName" className="label-update">Nume trupa</label>
            <input type="text" name="bandName" id="bandName" value={band?.bandName} onChange={(e) => handleChange(e, setBand)} />

            <label htmlFor="membersNb" className="label-update">Numar total membri</label>
            <input type="number" name="membersNb" id="membersNb" value={band?.membersNb} onChange={(e) => handleChange(e, setBand)} />

            <label htmlFor="minorsNb" className="label-update">Numar membri minori</label>
            <input type="number" name="minorsNb" id="minorsNb" value={band?.minorsNb} onChange={(e) => handleChange(e, setBand)} />

            <label htmlFor="city" className="label-update">Localitate</label>
            <input type="text" name="city" id="city" value={band?.city} onChange={(e) => handleChange(e, setBand)} />

            <label htmlFor="playName" className="label-update">Nume piesa</label>
            <input type="text" name="playName" id="playName" value={play?.playName} onChange={(e) => handleChange(e, setPlay)} />

            <label htmlFor="author" className="label-update">Autor piesa</label>
            <input type="text" name="author" id="author" value={play?.author} onChange={(e) => handleChange(e, setPlay)} />

            <label htmlFor="genre" className="label-update">Gen</label>
            <input type="text" name="genre" id="genre" value={play?.genre} onChange={(e) => handleChange(e, setPlay)} />

            <label htmlFor="direction" className="label-update">Regie</label>
            <input type="text" name="direction" id="direction" value={play?.direction} onChange={(e) => handleChange(e, setPlay)} />

            <label htmlFor="description" className="label-update">Descriere</label>
            <textarea name="description" id="description" value={play?.description} onChange={(e) => handleChange(e, setPlay)} />

            <label htmlFor="duration" className="label-update">Durata spectacol (min)</label>
            <input type="number" name="duration" id="duration" value={play?.duration} onChange={(e) => handleChange(e, setPlay)} />

            <label htmlFor="assemblingTime" className="label-update">Timp montare decor (min)</label>
            <input type="number" name="assemblingTime" id="assemblingTime" value={play?.assemblingTime} onChange={(e) => handleChange(e, setPlay)} />

            <label htmlFor="disassemblingTime" className="label-update">Timp demontare decor (min)</label>
            <input type="number" name="disassemblingTime" id="disassemblingTime" value={play?.disassemblingTime} onChange={(e) => handleChange(e, setPlay)} />

            <label htmlFor="requirements" className="label-update">Cerinte decor</label>
            <input type="text" name="requirements" id="requirements" value={play?.requirements} onChange={(e) => handleChange(e, setPlay)} />

            <label htmlFor="linkShow" className="label-update">Link filmare</label>
            <input type="text" name="linkShow" id="linkShow" value={play?.linkShow} onChange={(e) => handleChange(e, setPlay)} />

            <label htmlFor="linkScript" className="label-update">Link scenariu</label>
            <input type="text" name="linkScript" id="linkScript" value={play?.linkScript} onChange={(e) => handleChange(e, setPlay)} />

            <label htmlFor="triggerWarnings" className="label-update">Impacte emoționale</label>
            <textarea name="triggerWarnings" id="triggerWarnings" value={play?.triggerWarnings} onChange={(e) => handleChange(e, setPlay)} />

            <label htmlFor="lastNameRepresentative" className="label-update">Nume reprezentant</label>
            <input type="text" name="lastNameRepresentative" id="lastNameRepresentative" value={band?.lastNameRepresentative} onChange={(e) => handleChange(e, setBand)} />

            <label htmlFor="firstNameRepresentative" className="label-update">Prenume reprezentant</label>
            <input type="text" name="firstNameRepresentative" id="firstNameRepresentative" value={band?.firstNameRepresentative} onChange={(e) => handleChange(e, setBand)} />

            <label htmlFor="phoneNumberRepresentative" className="label-update">Numar telefon</label>
            <input type="text" name="phoneNumberRepresentative" id="phoneNumberRepresentative" value={band?.phoneNumberRepresentative} onChange={(e) => handleChange(e, setBand)} />

            <label htmlFor="emailRepresentative" className="label-update">Email</label>
            <input type="text" name="emailRepresentative" id="emailRepresentative" value={band?.emailRepresentative} onChange={(e) => handleChange(e, setBand)} />

            <label htmlFor="isProfessional" className="label-update">Categorie</label>
            <input type="text" name="isProfessional" id="isProfessional" value={band?.isProfessional ? "Profesionisti" : "Amatori"} onChange={(e) => handleChange(e, setBand)} />

            <label htmlFor="requireAcommodation" className="label-update">Nevoie cazare</label>
            <input type="checkbox" name="requireAcommodation" id="requireAcommodation" checked={band?.requireAcommodation} onChange={(e) => ({ ...band, requireAcommodation: e.target.checked })} />

            <label htmlFor="requireFood" className="label-update">Nevoie mancare</label>
            <input type="checkbox" name="requireFood" id="requireFood" checked={band?.requireFood} onChange={(e) => ({ ...band, requireFood: e.target.checked })} />

            <label htmlFor="additionalRequirements" className="label-update">Nevoi suplimentare</label>
            <input type="text" name="additionalRequirements" id="additionalRequirements" value={band?.additionalRequirements} onChange={(e) => handleChange(e, setBand)} />

            <button onClick={updateButton} className="buton">
                Update Trupa
            </button>

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />

        </div>
    )
}

export default UpdateTrupa;